import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { showError } from '@feathr/components';
import { useAccount } from '@feathr/extender/state';

interface IUseStripeOnboardingRedirect {
  redirectToStripeOnboarding: (openInNewTab?: boolean) => Promise<void>;
}

/**
 * Hook to handle Stripe onboarding URL fetching and redirection.
 * This can be used to open a new Stripe onboarding link when the previous one-time link has expired.
 */
export function useStripeOnboardingRedirect(): IUseStripeOnboardingRedirect {
  const { t } = useTranslation();
  const account = useAccount();

  const redirectToStripeOnboarding = useCallback(
    async (openInNewTab = false): Promise<void> => {
      try {
        const response = await account.getStripeOnboardingLink();
        if (response.data.url) {
          if (openInNewTab) {
            globalThis.open(response.data.url, '_blank');
          } else {
            globalThis.location.href = response.data.url;
          }
        }
      } catch (error) {
        showError(error, t);
      }
    },
    [account, t],
  );

  return { redirectToStripeOnboarding };
}
